export class ListAzureVirtualNetworksRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureVirtualNetworksRequest.attributeTypeMap;
    }
    constructor() {
    }
}
